import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

export const enhance = () => {
	const EnhancedMarker = (props) => {
		const { google, map, icon, label, labelClass, location } = props;
		const [marker, setMarker] = useState(null);
		const prevLocationRef = useRef(location);

		useEffect(() => {
			if (google && map) {
				const newMarker = new google.maps.Marker({
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude,
					),
					map,
					icon,
					label,
					labelClass,
					zIndex: 100,
				});

				setMarker(newMarker);

				return () => {
					newMarker.setMap(null);
				};
			}
		}, []); // eslint-disable-line react-hooks/exhaustive-deps

		useEffect(() => {
			if (marker && prevLocationRef.current !== location) {
				const position = new google.maps.LatLng(
					location.latitude,
					location.longitude,
				);
				marker.setPosition(position);
			}
			prevLocationRef.current = location;
		}, [location, marker, google]);

		return null;
	};
	EnhancedMarker.propTypes = {
		google: PropTypes.shape({
			maps: PropTypes.shape({
				Marker: PropTypes.func,
				LatLng: PropTypes.func,
			}),
		}),
		map: PropTypes.object,
		icon: PropTypes.object,
		label: PropTypes.string,
		labelClass: PropTypes.string,
		location: PropTypes.shape({
			latitude: PropTypes.number,
			longitude: PropTypes.number,
		}),
	};
	return EnhancedMarker;
};

export default enhance();
